
export const it = {
  translation: {
    common: {
      save: "Salva",
      cancel: "Annulla",
      edit: "Modifica",
      delete: "Elimina",
      create: "Crea",
      new: "Nuovo",
      search: "Cerca...",
      loading: "Caricamento...",
      export: "Esporta",
      all: "Tutti",
      open: "Aperto",
      closed: "Chiuso",
      back: "Indietro",
      confirm: "Conferma",
      scan: "Scan",
      view_all: "Vedi tutti",
      show_more: "Mostra altri",
      logout: "Esci",
      work_in_progress: "Lavori in corso",
      user: "Utente",
      saving: "Salvataggio...",
      unknown: "Sconosciuto",
      select: "Seleziona...",
      save_success: "Modifiche salvate con successo",
      save_error: "Errore salvataggio",
      unexpected_error: "Errore imprevisto",
      save_changes: "Salva Modifiche",
      delete_confirm_title: "Conferma Eliminazione",
      delete_success: "Eliminato con successo",
      delete_error: "Errore durante l'eliminazione",
      activate: "Attiva",
      deactivate: "Disattiva",
      add: "Aggiungi",
      no_data: "Nessun dato presente",
      no_options: "Nessuna opzione",
      days: {
        monday: "Lunedì",
        tuesday: "Martedì",
        wednesday: "Mercoledì",
        thursday: "Giovedì",
        friday: "Venerdì",
        saturday: "Sabato",
        sunday: "Domenica"
      },
      org_missing: "Organizzazione mancante",
      error: "Errore",
      connection_error: "Errore di connessione"
    },
    date_picker: {
      placeholder: "Seleziona data",
      days_short: ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"]
    },
    roles: {
      admin: "Proprietario",
      manager: "Manager",
      staff: "Dipendente",
      user: "Utente"
    },
    login: {
      welcome_back: "Bentornato",
      create_account: "Crea Account",
      subtitle: "Accedi per gestire il tuo salone.",
      email: "Email",
      password: "Password",
      forgot_password: "Password dimenticata?",
      signin_btn: "Accedi",
      signup_btn: "Registrati",
      no_account: "Non hai un account?",
      has_account: "Hai già un account?",
      signup_link: "Registrati ora",
      signin_link: "Accedi",
      check_email: "Controlla la tua email per il link di conferma!",
      error_generic: "Si è verificato un errore durante l'autenticazione."
    },
    sidebar: {
      HOME: "Home",
      CALENDAR: "Calendario",
      CUSTOMERS: "Clienti",
      STAFF: "Dipendenti",
      ANALYTICS: "Analytics",
      ASSISTANT: "Assistente AI",
      SALON: "Salone",
      BILLING: "Fatturazione",
      INVENTORY: "Magazzino",
      MEDIA: "Media Creation",
      PROFILE: "Profilo",
      SETTINGS: "Impostazioni"
    },
    home: {
      greeting: "Ciao {{name}}, che bello rivederti!",
      subtitle: "Il salone è pronto per una grande giornata.",
      subtitle_today_count_one: "Oggi hai {{count}} appuntamento in programma",
      subtitle_today_count_other: "Oggi hai {{count}} appuntamenti in programma",
      subtitle_today_empty: "Nessun appuntamento in programma per oggi",
      get_boost: "Get Boost",
      new_appointment: "Nuovo Appuntamento",
      new_appointment_desc: "Hai un cliente in attesa o una chiamata? Aggiungi subito la prenotazione.",
      book_now: "Prenota Ora",
      view_agenda: "Vedi Agenda",
      active_agenda: "Agenda Attiva",
      revenue_month: "Fatturato Ottobre",
      weekly_activity: "Attività Settimanale",
      confirmed_bookings: "Prenotazioni confermate",
      total: "Totale",
      upcoming_appointments: "Prossimi Appuntamenti",
      view_all: "Vedi tutti",
      revenue_today_title: "Incassi di oggi",
      bookings_today: "Appuntamenti oggi",
      weekly_empty_state: "Nessun dato disponibile per questa settimana",
      no_upcoming_appointments: "Nessun appuntamento in programma",
      upcoming_placeholder_subtitle: "Il prossimo appuntamento apparirà qui.",
      more_upcoming: "altri appuntamenti in programma",
      unknown_service: "Servizio sconosciuto",
      unknown_client: "Cliente sconosciuto",
      unknown_staff: "Staff",
      tooltip_day_label: "Giorno",
      tooltip_bookings_label: "Prenotazioni",
      tooltip_revenue_label: "Incasso"
    },
    calendar: {
      today: "Oggi",
      day: "Giorno",
      week: "Settimana",
      month: "Mese",
      new_appointment: "Nuovo",
      staff_agenda: "Agenda di:",
      free: "Libero",
      busy: "Occupato",
      full: "Pieno",
      more_than_n_parallel: "Più di {{count}} in parallelo",
      n_appointments: "+{{count}} Appuntamenti",
      no_service_for_staff: "Il dipendente selezionato non ha servizi assegnati.",
      all_staff_busy: "Nessun dipendente disponibile in questo orario.",
      shop_closed: "Il salone è chiuso in questo giorno o orario.",
      outside_hours: "Orario fuori dall'orario di apertura o del turno del dipendente.",
      overlap_break: "L'orario scelta si sovrappone alla pausa.",
      overlap_booking: "Esiste già un appuntamento in questo slot per questo dipendente.",
      overlap_vacation: "Il dipendente è in ferie o ha un permesso in questo periodo.",
      overlapping_error: "Impossibile spostare l'appuntamento.",
      staff_no_service: "Il dipendente non offre questo servizio con la stessa durata/prezzo.",
      event_updated: "Appuntamento aggiornato con successo.",
      confirm_move_title: "Spostamento appuntamento",
      confirm_move_desc: "Vuoi confermare lo spostamento di questo appuntamento?"
    },
    download_app: {
      loading: "Caricamento in corso...",
      not_found_title: "Salone non trovato",
      not_found_desc: "Non siamo riusciti a trovare le informazioni di questo salone. Assicurati che il link sia corretto.",
      book_now: "Prenota subito da",
      why_use_app: "Perché usare l'app",
      feature_1: "Prenota 24/7 in pochi secondi",
      feature_2: "Gestisci i tuoi appuntamenti",
      feature_3: "Ricevi promemoria automatici",
      download_free: "Scarica gratis Clip"
    },
    customers: {
      title: "Clienti",
      subtitle: "Gestisci l'anagrafica e lo storico dei tuoi clienti.",
      new_customer: "Nuovo Cliente",
      appointments: "Storico Appuntamenti",
      last_visit: "Ultima visita",
      verified: "Verificata",
      not_verified: "Non Verificata",
      never_visited: "Mai visitato",
      discover_duplicates: "Scopri Duplicati",
      merged_badge: "Unito",
      duplicates: {
        title: "Risoluzione Duplicati",
        description: "Abbiamo raggruppato i clienti che condividono lo stesso telefono o la stessa email. Chi ha soltanto nome e cognome uguali non compare: sono persone diverse. Seleziona un gruppo per unire i profili in uno solo, lo storico degli appuntamenti rimarrà intatto.",
        group: "Gruppo",
        profiles: "Profili",
        common_phone: "Telefono in comune",
        common_email: "Email in comune",
        empty_title: "Nessun duplicato trovato",
        empty_description: "Non ci sono clienti che condividono lo stesso telefono o la stessa email.",
        merging: "Unione in corso...",
        merge_selected: "Unisci Selezionati",
        merge_confirm_title: "Unire i clienti selezionati?",
        merge_confirm_desc: "Questa operazione unirà definitivamente i profili selezionati.",
        merge_confirm_btn: "Conferma Unione"
      },
      modal: {
        title: "Scheda Cliente",
        create_title: "Nuovo Cliente",
        create_subtitle: "Aggiungi un nuovo cliente al database.",
        email: "Email",
        phone: "Telefono",
        notes: "Note & Preferenze",
        delete: "Elimina Cliente",
        save_changes: "Salva Modifiche",
        customer_since: "Cliente dal",
        no_name: "Cliente senza nome",
        name: "Nome",
        surname: "Cognome",
        create_btn: "Crea Cliente",
        email_optional: "Email (Opzionale)",
        phone_optional: "Telefono (Opzionale)",
        no_notes: "Nessuna nota presente per questo cliente.",
        no_appointments: "Nessun appuntamento registrato.",
        confirm_title: "Confermi l'azione?",
        blocked: "Bloccato",
        block: "Blocca",
        unblock: "Sblocca",
        delete_confirm_desc: "Questa azione eliminerà definitivamente {{name}}. L'operazione non può essere annullata.",
        block_confirm_desc: "Questa azione bloccherà {{name}} dalle prenotazioni presso il salone.",
        unblock_confirm_desc: "Questa azione sbloccherà {{name}} dalle prenotazioni presso il salone.",
        reset_reports_title: "Azzera Segnalazioni",
        reset_reports_confirm_desc: "Questa azione eliminerà definitivamente tutte le segnalazioni per {{name}}. L'operazione non può essere annullata.",
        reset: "Azzera",
        archived_title: "Cliente Archiviato",
        archived_description: "Questo profilo è stato unito ad un altro. Non è possibile modificare o eliminare i dati da questa vista.",
        toast: {
          name_required: "Il nome è obbligatorio",
          phone_required: "Il telefono è obbligatorio",
          update_error: "Errore nell'aggiornamento del cliente",
          update_success: "Cliente aggiornato con successo",
          delete_error: "Errore durante l'eliminazione del cliente",
          delete_success: "Cliente eliminato con successo",
          block_error: "Errore nel blocco del cliente",
          block_success: "Cliente bloccato con successo",
          unblock_error: "Errore nello sblocco del cliente",
          unblock_success: "Cliente sbloccato con successo",
          op_error: "Errore durante l'operazione"
        }
      }
    },
    bookings: {
      status_confirmed: "Confermato",
      status_pending: "In attesa",
      status_cancelled: "Cancellato",
      status_no_show: "No-Show",
      modal: {
        title: "Dettagli prenotazione",
        subtitle: "Visualizza i dettagli della prenotazione",
        created_at: "Prenotazione effettuata il: {{date}}",
        delete_confirm: "Confermi l'eliminazione di questa prenotazione? L'operazione non può essere annullata.",
        delete_error: "Errore durante l'eliminazione della prenotazione",
        delete_success: "Prenotazione eliminata con successo",
        delete_unexpected: "Si è verificato un errore imprevisto durante l'eliminazione.",
        service: "Servizio",
        service_not_found: "Servizio non trovato",
        hairdresser: "Dipendente",
        hairdresser_not_found: "Dipendente non trovato",
        client: "Cliente",
        client_not_found: "Cliente non trovato",
        call_client: "Chiama",
        notes: "Note",
        edit_btn: "Modifica prenotazione",
        delete_btn: "Elimina",
        report_success: "Cliente segnalato con successo",
        client_blocked_title: "Attenzione: Cliente bloccato",
        client_blocked_desc: "Questo cliente è bloccato e non può effettuare prenotazioni",
        report_warning: "Attenzione: Cliente segnalato",
        report_reason: "Motivo della segnalazione:",
        report_no_reason: "Nessun motivo specificato",
        report_and_block_btn: "Segnala e blocca",
        report_btn: "Segnala",
        blocked_title: "Bloccato",
        reports_count: "Segnalazioni",
        no_show_success: "Stato impostato su No Show",
        no_show_banner_title: "Mancata presentazione (No-Show)",
        no_show_banner_desc: "Il cliente non si è presentato a questo appuntamento."
      },
      report: {
        reason_no_show: "Non si è presentato senza avvisare",
        reason_late_cancel: "Ha disdetto all'ultimo minuto",
        reason_other: "Altro",
        badge: "Segnalazione",
        title: "Segnala Cliente",
        description: "Stai per segnalare il cliente",
        description_sub: "Scegli il motivo della segnalazione di seguito:",
        other_reason_label: "Specifica il motivo",
        other_reason_placeholder: "Inserisci una motivazione...",
        confirm_btn: "Segnala"
      }
    },
    staff: {
      title: "Dipendenti",
      subtitle: "Gestisci il team, i permessi e i ruoli.",
      new_staff: "Nuovo Staff",
      defaults: {
        first_name: "Nome",
        last_name: "Cognome",
        guest: "Invitato"
      },
      invite_modal: {
        title: "Invita Staff",
        subtitle: "Invia un'email di invito a un nuovo collaboratore.",
        email_label: "Email di Invito",
        role_label: "Ruolo",
        send_invite: "Invia Invito",
        helper: "Il collaboratore riceverà un link per creare il proprio account."
      },
      card: {
        invite: "Invito",
        invite_pending: "Invito non ancora accettato",
        role: "Ruolo",
        status_label: "Stato",
        verified: "Email Verificata",
        not_verified: "Email Non Verificata",
        deactivate: "Disattiva Account",
        activate: "Attiva Account",
        details_title: "Dettagli Dipendente",
        verify_account: "Verifica Account",
        has_access: "L'utente ha accesso alla piattaforma.",
        needs_confirm: "L'utente deve confermare l'email per accedere.",
        resend: "Reinvia",
        status: {
          active: "Attivo",
          inactive: "Inattivo",
          holiday: "Ferie"
        }
      },
      details: {
        form: {
          first_name: "Nome",
          last_name: "Cognome",
          email: "Email",
          phone: "Telefono",
          role: "Ruolo"
        },
        verification_status: "Stato Verifica Account",
        verified: "Email Verificata",
        pending: "In attesa di conferma",
        send_reset: "Invia Reset Password",
        toast: {
          status_change: "Utente {{status}}",
          status_error: "Errore cambio stato",
          self_deactivation_error: "Non puoi disattivare il tuo stesso account",
          self_deletion_error: "Non puoi eliminare il tuo stesso account",
          admin_deactivation_error: "Non puoi disattivare un admin come membro dello staff",
          admin_deletion_error: "Non puoi eliminare un admin"
        },
        invite_delete: {
          title: "Elimina Invito",
          description: "Sei sicuro di voler annullare questo invito? Il link inviato via email non sarà più valido.",
          success: "Invito eliminato",
          error: "Errore durante l'eliminazione"
        },
        confirm_deactivate: "Sei sicuro di voler disattivare questo membro dello staff? Non potrà più accedere.",
        confirm_activate: "Vuoi riattivare questo membro dello staff?",
        confirm_delete: "Sei sicuro di voler eliminare questo dipendente? Questa azione è irreversibile."
      },
      hours: {
        config_title: "Configurazione Turni",
        config_desc: "Usa il toggle su ogni giorno per attivare/disattivare.",
        working: "Lavorativo",
        rest: "Riposo",
        split: "Spezzato",
        continuous: "Continuato",
        morning: "Mattina",
        afternoon: "Pom.",
        schedule: "Orario",
        save: "Salva Orari",
        toast: {
          saved: "Orari salvati con successo"
        },
        error_morning: "Orario {{day}}: L'apertura deve precedere l'inizio pausa.",
        error_break: "Orario {{day}}: L'inizio pausa deve precedere la fine pausa.",
        error_afternoon: "Orario {{day}}: La fine pausa deve precedere la chiusura.",
        error_continuous: "Orario {{day}}: L'apertura deve precedere la chiusura."
      },
      timeoff: {
        vacation_tab: "Ferie (Giorni)",
        permission_tab: "Permessi (Ore)",
        vacation_planned: "Ferie Pianificate",
        permission_requested: "Permessi Richiesti",
        from: "Dal",
        to: "Al",
        day: "Giorno",
        start_time: "Dalle",
        end_time: "Alle",
        toast: {
          dates_missing: "Date mancanti",
          date_end_error: "Data fine errata",
          data_missing: "Dati mancanti",
          added: "Aggiunto!",
          deleted: "Eliminato!"
        },
        start_placeholder: "Inizio",
        end_placeholder: "Fine"
      },
      shiftchanges: {
        tab: "Cambi Turno",
        planned: "Cambi Turno Pianificati",
        open_time: "Apertura",
        close_time: "Chiusura",
        break_start: "Inizio pausa",
        break_end: "Fine pausa",
        break: "Pausa",
        toast: {
          added: "Cambio turno aggiunto!",
          deleted: "Cambio turno eliminato!"
        }
      }
    },
    analytics: {
      title: "Analytics",
      subtitle: "Monitora le performance del tuo salone in tempo reale.",
      kpi: {
        revenue: "Fatturato Totale",
        appointments: "Appuntamenti",
        avg_ticket: "Scontrino Medio",
        new_customers: "Nuovi Clienti"
      },
      charts: {
        revenue_trend: "Andamento Fatturato",
        revenue_subtitle: "Entrate giornaliere di Ottobre",
        services_mix: "Mix Servizi",
        services_subtitle: "Distribuzione per categoria",
        staff_perf: "Performance Staff",
        top_products: "Prodotti Top",
        view_stock: "Vedi Magazzino",
        analyze_stock: "Analisi Magazzino",
        units_sold: "unità vendute"
      },
      export_excel: "Export Excel",
      exporting: "Export...",
      other: "Altro"
    },
    email_confirmed: {
      title: "Email Verificata!",
      subtitle: "Il tuo indirizzo email è stato confermato con successo. Torna in app per sfruttare i tuoi nuovi privilegi!",
      button: "Apri App",
      redirect: "Apertura app automatica in {{count}}s",
    },
    salon: {
      title: "Il Tuo Salone",
      subtitle: "Gestisci profilo, servizi, orari e recensioni.",
      generate_link: "Pagina Salone",
      download_qr: "Scarica QR",
      qr_download_success: "QR Code scaricato con successo!",
      qr_download_error: "Errore durante la generazione del QR Code",
      tabs: {
        profile: "Profilo",
        services: "Servizi",
        hours: "Orari & Ferie",
        gallery: "Galleria",
        reviews: "Recensioni",
        trophies: "Obiettivi",
        settings: "Impostazioni"
      },
      profile: {
        general_info: "Informazioni Generali",
        name: "Nome Salone",
        vat: "Partita IVA",
        desc: "Descrizione",
        address: "Indirizzo",
        city: "CAP & Città",
        contacts: "Contatti",
        edit_cover: "Modifica Cover",
        delete: {
          title: "Elimina Cover",
          description: "Sei sicuro di voler rimuovere l'immagine di copertina del tuo salone?",
          confirm: "Rimuovi Cover",
        },
        banner_updated: "Banner aggiornato",
        banner_removed: "Banner rimosso",
        validation: {
          name_required: "Nome del salone richiesto",
          vat_invalid: "Partita IVA non valida (richieste 11 cifre)",
          phone_required: "Telefono richiesto",
          email_invalid: "Email non valida"
        },
        notifications: {
          title: "Notifiche",
          settings_title: "Impostazioni Salone",
          settings_constraints_label: "Vincoli calendario",
          settings_constraints_desc: "Se attivo, rispetta pause, orari e ferie nel calendario",
          dynamic_slots_label: "Slot dinamici",
          dynamic_slots_desc: "Abilita la visualizzazione dinamica degli slot a seconda del servizio selezionato in app",
          multicolor_label: "Appuntamenti multicolore",
          multicolor_desc: "Colora ogni appuntamento con una tinta diversa a rotazione, invece del colore unico arancione",
          max_booking_range_label: "Limite mesi visibili in app",
          max_booking_range_desc: "Numero massimo di mesi in cui i clienti possono prenotare nel futuro",
          app_booking_label: "Prenotazioni in app",
          app_booking_desc: "Abilita o disabilita le prenotazioni tramite l'applicazione",
          appointments_label: "Email appuntamenti",
          appointments_desc: "Ricevi email per nuovi appuntamenti e aggiornamenti",
          max_reports_label: "Limite segnalazioni clienti",
          max_reports_desc: "Numero massimo di segnalazioni prima che il cliente venga bloccato",
          cancellation_limit_label: "Limite ore disdetta",
          cancellation_limit_desc: "Fino a quante ore prima è possibile disdire un appuntamento",
          report_policy_label: "Messaggio al cliente in caso di segnalazione",
          report_policy_desc: "Il testo che il cliente riceve se viene segnalato. Meglio un tono umano e gentile, non legale.",
          report_policy_placeholder: "Facoltativo. Es: \"Ci dispiace che non sia andata come previsto! Se non puoi venire, avvisaci in tempo: la disdetta è gratuita fino a 24h prima.\""
        }
      },
      services: {
        new_service: "Nuovo Servizio",
        duration: "min",
        filters: {
          all: "Tutti",
          all_staff: "Tutto lo Staff",
          filter_staff: "Filtra Staff",
        },
        empty_state: "Nessun servizio trovato.",
        delete: {
          title: "Eliminare il servizio?",
          description: "Stai per rimuovere \"{{name}}\". Questa azione non può essere annullata.",
          confirm: "Elimina",
        },
        toast: {
          delete_success: "Servizio rimosso dal listino",
          delete_error: "Errore durante l'eliminazione",
          create_success: "Servizio aggiunto!",
          create_error: "Errore creazione servizio",
        },
        form: {
          name_label: "Nome Servizio",
          name_placeholder: "es. Taglio Sfumato",
          category_label: "Categoria",
          staff_label: "Chi lo fa?",
          select_staff: "Seleziona Staff...",
          price_label: "Prezzo",
          duration_label: "Durata",
          duration_placeholder: "Minuti",
          new_service_desc: "Aggiungi un nuovo trattamento al listino.",
        }
      },
      hours: {
        opening_hours: "Orari di Apertura",
        holidays: "Ferie",
        add_period: "Aggiungi periodo di chiusura",
        time_step: "Step Orario",
        time_step_desc: "Scegli l'intervallo di tempo (in minuti) con cui dividere la tua agenda e i tuoi servizi.",
        time_step_placeholder: "Seleziona Step Orario",
        time_step_updated: "Step orario aggiornato con successo",
        time_step_error: "Errore durante l'aggiornamento dello step orario",
        minutes_label: "{{minutes}} Minuti"
      },
      reviews: {
        based_on: "Basato su",
        load_more: "Carica altre recensioni"
      },
      trophies: {
        title: "Programma Fedeltà",
        subtitle: "Imposta i traguardi che i tuoi clienti possono raggiungere prenotando tramite l'app.\nPiù prenotano, più salgono di livello e sbloccano premi esclusivi.",
        active_levels: "Livelli Attivi",
        add_level: "Aggiungi Livello",
        empty_state: "Non ci sono ancora livelli per questo salone.",
        stat_participants: "Clienti Partecipanti",
        stat_redeemed: "Premi Riscattati",
        level_prefix: "TRAGUARDO",
        threshold: "Soglia Raggiungimento",
        bookings: "prenotazioni",
        reward_prefix: "Vince:",
        delete_title: "Elimina Livello",
        delete_desc: "Sei sicuro di voler eliminare il livello \"{{name}}\"?",
        delete_confirm: "Elimina",
        toast: {
          updated: "Livello aggiornato",
          created: "Livello creato",
          deleted: "Livello eliminato",
          error: "Si è verificato un errore",
          delete_error: "Errore durante l'eliminazione"
        },
        modal: {
          title_new: "Nuovo Obiettivo",
          title_edit: "Modifica Obiettivo",
          subtitle: "Definisci un nuovo traguardo per i tuoi clienti fedeli.",
          name_label: "Nome Livello",
          name_placeholder: "es. Bronze Member",
          value_label: "Prenotazioni Richieste",
          value_placeholder: "es. 10",
          value_helper: "Il numero di prenotazioni necessario per sbloccare questo livello",
          prize_label: "Premio",
          prize_placeholder: "es. Taglio Omaggio",
          prize_helper: "Cosa vince il cliente una volta raggiunto l'obiettivo",
          create_btn: "Crea Livello",
          save_btn: "Salva Modifiche"
        }
      }
    },
    billing: {
      title: "Fatturazione & Piano",
      subtitle: "Gestisci il tuo abbonamento e scarica le ricevute.",
      secure_payment: "Pagamenti sicuri via Stripe",
      active_plan: "Piano Attivo",
      features: {
        unlimited_staff: "Dipendenti Illimitati",
        staff_limit: "Fino a 2 Dipendenti",
        bookings_limit: "Fino a 200 Prenotazioni",
        unlimited_bookings: "Prenotazioni Illimitate",
        unlimited_emails: "Email Illimitate",
        advanced_agenda: "Agenda Digitale Avanzata",
        analytics: "Analytics Premium",
        support: "Supporto Prioritario 24/7"
      },
      usage_sms: "SMS Inviati questo mese",
      manage_plan: "Gestisci Piano",
      upgrade_plan: "Effettua Upgrade",
      invoices_history: "Storico Fatture",
      view_all_invoices: "Vedi tutte le fatture",
      payment_method: "Metodo di Pagamento",
      next_renewal: "Prossimo Rinnovo",
      renewal_text: "Il rinnovo automatico avverrà il",
      update_method: "Aggiorna Metodo",
      help_title: "Hai bisogno di aiuto?",
      help_text: "Se hai dubbi sulla fatturazione o vuoi cambiare piano aziendale, contattaci.",
      contact_support: "Contatta Supporto",
      month: "mese",
      year: "anno",
      expires: "Scadenza",
      status: {
        paid: "Pagata",
        pending: "In attesa",
        failed: "Fallita"
      },
      ends_on: "Termina il:",
      plan_desc: "Tutto quello che ti serve per scalare il tuo salone.",
      no_invoices: "Nessuna fattura trovata",
      tabs: {
        plan: "Piano",
        visibility: "Visibilità"
      },
      visibility_title: "Boost Visibilità",
      visibility_desc: "Aumenta la visibilità del tuo salone e attrai più clienti.",
      upgrade_boost_title: "Upgrade il tuo boost",
      active_boost: "Boost Attivo",
      expires_on: "Scade il",
      upgrade_days: "Upgrade a {{days}} giorni",
      buy_btn: "Acquista",
      packages: {
        boost_1: {
          title: "Super Boost",
          description: "Massima visibilità per 24 ore. Ideale per riempire buchi last minute."
        },
        boost_7: {
          title: "Weekly Boost",
          description: "7 giorni di visibilità aumentata. Perfetto per promozioni settimanali.",
          badge: "SCONTO 40%"
        },
        boost_15: {
          title: "Premium Boost",
          description: "15 giorni di massima esposizione. Domina la tua zona.",
          badge: "SCONTO 63%",
          top_badge: "Più venduto"
        }
      }
    },
    products: {
      title: "Magazzino",
      subtitle: "Gestisci l'inventario, i prezzi e gli ordini ai fornitori.",
      new_product: "Nuovo Prodotto",
      stats: {
        value: "Valore Magazzino",
        total: "Prodotti Totali",
        reorder: "Da Riordinare"
      },
      scan: "Scan",
      stock_low: "SCORTA BASSA",
      stock_label: "Stock",
      units: "unità",
      products_lower: "prodotti",
      search_placeholder: "Cerca per nome, brand o codice...",
      categories: {
        all: "Tutti",
        haircare: "Haircare",
        styling: "Styling",
        color: "Colore",
        equipment: "Attrezzatura"
      }
    },
    media: {
      title: "Social Studio",
      subtitle: "Scegli un template, personalizzalo e pubblica in pochi secondi.",
      generate_ai: "Genera con AI",
      no_templates: "Nessun template trovato.",
      filters: {
        all: "Tutti",
        photo: "Foto",
        video: "Video"
      },
      categories: {
        all: "Tutti",
        promo: "Promo",
        quote: "Quote",
        product: "Product",
        seasonal: "Seasonal",
        event: "Event"
      },
      editor: {
        customize: "Personalizza",
        customize_desc: "Modifica il template in tempo reale.",
        texts: "Testi",
        media: "Media",
        stickers: "Sticker & Link",
        replace_bg: "Sostituisci Sfondo",
        add_sticker: "Aggiungi Sticker",
        remove_sticker: "Rimuovi Sticker",
        add_link: "Aggiungi Link",
        remove_link: "Rimuovi Link",
        link_text: "Testo Link (es. Prenota Ora)",
        link_url: "URL Link (es. www.miosito.it)",
        download: "Scarica Storia",
        download_clip: "Scarica Clip",
        saved_success: "Media salvato con successo!",
        title_placeholder: "Titolo",
        subtitle_placeholder: "Sottotitolo",
        cta_placeholder: "Call to Action"
      }
    },
    profile: {
      title: "Il Mio Profilo",
      subtitle: "Gestisci le tue informazioni personali e di accesso.",
      personal_stats: "Statistiche Personali",
      today_appts: "Appuntamenti Oggi",
      month_revenue: "Fatturato Mese",
      hours_worked: "Ore Lavorate Oggi",
      personal_data: "Dati Personali",
      bio: "Bio (visibile ai clienti)",
      security: "Sicurezza",
      password_last_changed: "Password: Ultima modifica",
      change_password: "Cambia Password",
      mfa: "Autenticazione a due fattori (2FA)",
      mfa_desc: "Aggiungi un livello di sicurezza extra al tuo account.",
      edit_profile: "Modifica Profilo",
      click_to_edit: "Clicca l'immagine per modificare",
      roles: {
        owner_admin: "Owner & Master Admin",
        staff: "Staff Member",
        admin: "Admin",
        user: "User"
      },
      form: {
        current_password: "Password Attuale",
        new_password: "Nuova Password",
        confirm_password: "Conferma Password",
        update_password: "Aggiorna Password",
        updating: "Aggiornamento..."
      },
      validation: {
        name_required: "Nome richiesto",
        surname_required: "Cognome richiesto",
        email_required: "Email richiesta",
        password_mismatch: "Le password non coincidono",
        fill_all: "Compila tutti i campi password"
      },
      toast: {
        avatar_success: "Avatar aggiornato con successo",
        avatar_error: "Errore durante l'aggiornamento dell'avatar",
        select_error: "Errore durante la selezione dell'avatar",
        update_success: "Profilo aggiornato con successo!",
        update_error: "Errore durante l'aggiornamento del profilo",
        password_success: "Password cambiata con successo!",
        password_error: "Errore durante il cambio password",
        generic_error: "Errore generico"
      },
      notifications: {
        title: "Notifiche",
        appointments_label: "Email appuntamenti",
        appointments_desc: "Ricevi email per nuovi appuntamenti e aggiornamenti"
      }
    },
    new_shop: {
      hero: {
        title: "Crea il tuo salone",
        subtitle: "Inizia la tua avventura.",
        switch_account: "Vuoi cambiare account?"
      },
      form: {
        title: "Nuovo Salone",
        shop_name: "Nome Salone",
        shop_email: "Email Salone",
        phone: "Telefono",
        vat_id: "Partita IVA",
        address: "Indirizzo",
        city: "Città",
        zip: "CAP",
        country: "Paese",
        create_btn: "Crea Salone",
        continue_btn: "Continua"
      },
      validation: {
        fill_all: "Compila tutti i campi richiesti",
        auth_error: "Errore di autenticazione. Ricarica la pagina e riprova."
      },
      notifications: {
        creation_error: "Errore durante la creazione del salone",
        success: "Salone creato con successo",
        loading: "Caricamento..."
      }
    },

    settings: {
      title: "Impostazioni",
      subtitle: "Configura le preferenze dell'applicazione e le integrazioni.",
      nav: {
        integrations: "Integrazioni",
        notifications: "Notifiche",
        general: "Generali"
      },
      language: {
        title: "Lingua",
        desc: "Seleziona la lingua dell'interfaccia.",
        it: "Italiano",
        en: "English"
      },
      integrations: {
        active: "Integrazioni Attive",
        connect: "Connetti",
        connected: "Connesso"
      },
      notifications: {
        preferences: "Preferenze Notifiche",
        labels: {
          new_booking: "Nuove Prenotazioni",
          new_booking_desc: "Ricevi una notifica quando un cliente prenota.",
          reminder: "Promemoria Appuntamenti",
          reminder_desc: "Avvisami 15 minuti prima di ogni appuntamento.",
          report: "Report Settimanale",
          report_desc: "Ricevi il riepilogo delle performance via email.",
          stock: "Alert Magazzino",
          stock_desc: "Notifica quando un prodotto è in esaurimento."
        }
      },
      payments: {
        title: "Pagamenti",
        desc: "Gestisci pagamenti e fatturazione.",
        stripe: "Stripe",
        connected: "Connesso"
      },
      legal: {
        title: "Note Legali",
        privacy: "Privacy Policy",
        terms: "Termini e Condizioni"
      },
      support: {
        title: "Hai bisogno di aiuto?",
        desc: "Il nostro team di supporto è disponibile per risolvere qualsiasi problema tecnico o domanda relativa al tuo account.",
        contact: "Contattaci"
      }
    },
    new_appointment: {
      title: "Nuovo Appuntamento",
      subtitle: "Inserisci i dettagli della prenotazione.",
      customer_label: "Cliente",
      select_customer: "Seleziona un cliente",
      staff_label: "Dipendente",
      service_label: "Servizio",
      select_service: "Scegli il trattamento",
      date_label: "Data",
      time_label: "Ora",
      notes_label: "Note Interne",
      notes_placeholder: "Allergie, preferenze, dettagli extra...",
      confirm_btn: "Aggiungi",
      staff_placeholder: "Seleziona Staff...",
      service_fallback: "Servizio",
      success_message: "Appuntamento creato con successo",
      discount_or_markup_btn: "+ Sconto o Maggiorazione",
      discount_or_markup_label: "Sconto o Maggiorazione",
      discount_or_markup_placeholder: "Seleziona tipo",
      value_label: "Valore (€)",
      adjustment_type_none: "Nessuna",
      adjustment_type_discount: "Sconto",
      adjustment_type_markup: "Maggiorazione",
      discount_too_high_error: "Lo sconto supera il prezzo del servizio (€{{price}})",
      discount_too_high_error_toast: "Lo sconto non può superare il prezzo del servizio"
    },
    notifications: {
      title: "Notifiche",
      mark_read: "Segna lette",
      view_all: "Vedi tutte le notifiche"
    },
    upgrade: {
      title: "Funzionalità Premium",
      desc_generic: "Questa funzionalità non è inclusa nel tuo piano. Effettua l'upgrade per sbloccarla.",
      desc_ai: "L'assistente AI, gli obiettivi e le statistiche avanzate sono inclusi nel piano AI. Effettua l'upgrade per sbloccarli.",
      desc_inventory: "Il magazzino è incluso nel piano AI. Effettua l'upgrade per sbloccarlo.",
      cta: "Upgrade Ora"
    },
    subscription: {
      hero: {
        title_simple: "Piani semplici.",
        title_power: "Potenza pura.",
        subtitle: "Scegli la flessibilità. Cambia o disdici quando vuoi. \nNessun costo nascosto, mai.",
        monthly: "Mensile",
        annual: "Annuale",
        save_badge: "-20%"
      },
      plans: {
        pro: {
          name: "Pro",
          desc: "Tutto quello che serve per gestire il salone.",
          features: ["Prenotazioni illimitate", "Fino a 3 collaboratori", "Agenda digitale e app", "Prenotazione online 24/7", "Profilo marketplace", "Supporto email"],
          btn: "Inizia con Pro"
        },
        ai: {
          name: "AI",
          desc: "Intelligenza e crescita per il tuo team.",
          features: ["Tutto il piano Pro", "Fino a 10 collaboratori", "AI illimitata e obiettivi", "Statistiche avanzate dipendenti", "Gestione magazzino", "Automazioni marketing", "Recensioni Google", "Supporto WhatsApp"],
          btn: "Passa ad AI"
        },
        enterprise: {
          name: "Enterprise",
          desc: "Per saloni multi-sede e grandi team.",
          features: ["Tutto il piano AI", "Collaboratori illimitati", "Multi-sede", "Onboarding personalizzato", "Supporto dedicato", "Report mensili"],
          btn: "Contattaci"
        },
        standard: {
          name: "Standard",
          desc: "L'essenziale per iniziare.",
          features: ["Agenda Avanzata", "Fino a 2 Dipendenti", "Fino a 200 Prenotazioni al mese", "Assistenza 24/7"],
          btn: "Inizia ora"
        },
        visibility: {
          name: "Visibilità",
          desc: "Perfetto per essere presenti sul marketplace ed acquisire nuovi clienti.",
          features: ["Presenza sul Marketplace", "Profilo Salone"],
          btn: "Acquista Visibilità"
        },
        professional: {
          name: "Professional",
          desc: "Per chi vuole crescere sul serio.",
          features: ["Tutto incluso in Standard", "Dipendenti Illimitati", "Prenotazioni Illimitate"],
          btn: "Passa a Pro"
        },
        business: {
          name: "Business +",
          desc: "La potenza per i grandi brand.",
          features: ["Tutto in Professional", "Soluzioni Personalizzate", "Gestione Centralizzata Multi-sede"],
          btn: "Contattaci"
        },
        common: {
          popular: "Più venduto",
          custom: "Su misura",
          billed_yearly: "Fatturato annualmente",
          billed_monthly: "Fatturato mensilmente",
          save_badge: "SAVE 20%",
          month: "mese",
          year: "anno"
        }
      },
      comparison: {
        title: "Confronto dettagliato",
        features_header: "Funzionalità",
        categories: {
          core: "Core Features",
          experience: "Esperienza Cliente",
          marketing: "Marketing & Growth",
          management: "Gestione & Analytics",
          ai_goals: "AI & Obiettivi",
          staff: "Team & Analisi",
          support: "Supporto"
        },
        rows: {
          monthly_bookings: "Prenotazioni mensili",
          collaborators: "Collaboratori",
          ai_assistant: "Assistente AI",
          goals_plans: "Obiettivi e piani d'azione",
          staff_performance: "Statistiche avanzate dipendenti",
          staff_costs: "Spesa per dipendente",
          monthly_reports: "Report mensili",
          marketing_automations: "Automazioni marketing",
          google_reviews: "Recensioni Google",
          custom_onboarding: "Onboarding personalizzato",
          support_email: "Supporto email",
          support_whatsapp: "Supporto WhatsApp",
          support_dedicated: "Supporto dedicato",
          digital_agenda: "Agenda digitale",
          mobile_app_admin: "App mobile (Admin)",
          online_booking: "Prenotazione Online 24/7",
          app_reminders: "Promemoria Appuntamenti",
          custom_app: "App Clienti Personalizzata",
          waiting_list: "Lista d'attesa automatica",
          marketplace: "Profilo Marketplace",
          marketing_campaigns: "Campagne Marketing",
          verified_reviews: "Recensioni Certificate",
          loyalty_program: "Programma Fedeltà",
          stock_management: "Gestione Magazzino",
          electronic_invoicing: "Fatturazione Elettronica",
          advanced_reports: "Report Avanzati",
          multi_location: "Multi-sede"
        },
        values: {
          unlimited: "Illimitate",
          unlimited_staff: "Illimitati",
          unlimited_roles: "Illimitati + ruoli",
          email_only: "Email",
          email_push: "Email + Push",
          base: "Base",
          advanced: "Avanzato",
          custom_kpi: "Custom KPI",
          up_to_200: "Fino a 200",
          up_to_3: "Fino a 3",
          up_to_10: "Fino a 10",
          ai_unlimited: "Illimitata"
        }
      },
      footer: {
        doubts: "Dubbi?",
        subtitle: "Parla direttamente con noi. Siamo veloci, umani e pronti ad aiutarti a configurare tutto.",
        book_demo: "Prenota una Demo",
        whatsapp: "Scrivici su WhatsApp",
        email_contact: "Invia una Email"
      },
      demo: {
        title: "Scegli il momento perfetto",
        subtitle: "I nostri esperti ti mostreranno come Clip può trasformare il tuo salone in 20 minuti.",
        close: "Chiudi Calendario"
      },
      errors: {
        checkout_error: "Errore durante la creazione della sessione di checkout",
        redirect: "Attendere reindirizzamento al checkout...",
        generic: "Si è verificato un errore imprevisto."
      }
    },
    auth: {
      validation: {
        email_invalid: "Inserisci un indirizzo email valido",
        password_required: "La password è richiesta",
        name_min: "Il nome deve contenere almeno 2 caratteri",
        password_min: "La password deve contenere almeno 6 caratteri",
        terms_required: "Devi accettare i Termini e Condizioni",
        privacy_required: "Devi accettare la Privacy Policy"
      },
      branding: {
        login: {
          title_prefix: "La tua ",
          title_highlight: "dashboard",
          subtitle_prefix: "Tutto il salone in un ",
          subtitle_highlight: "click",
          footer_text: "Se non hai un account puoi Registrarti!",
          footer_btn: "Registrati ora"
        },
        register: {
          title_highlight: "Bentornato",
          subtitle: "Unisciti a noi e trasforma la gestione del tuo lavoro.",
          footer_text: "Hai già un account?",
          footer_btn: "Accedi al tuo account"
        },
        forgot: {
          title_prefix: "Non ",
          title_highlight: "preoccuparti",
          subtitle: "Succede a tutti. Ti aiuteremo a recuperare l'accesso in un attimo.",
          footer_btn: "Torna al Login"
        }
      },
      register: {
        full_name: "Nome Completo",
        terms_prefix: "Dichiaro di aver letto e di accettare i ",
        terms_link: "Termini e Condizioni",
        privacy_prefix: "Dichiaro di aver letto l'",
        privacy_link: "Informativa sulla Privacy",
        submit_btn: "Registrati"
      },
      forgot: {
        email_sent_title: "Email Inviata!",
        email_sent_desc: "Se l'indirizzo {{email}} è associato a un account, riceverai un link per resettare la password.",
        recovery_email: "Email di recupero",
        submit_btn: "Invia Link"
      },
      deactivated: {
        title: "Account Disattivato",
        subtitle: "Il tuo accesso alla piattaforma è stato sospeso.",
        what_to_do_title: "Cosa fare?",
        what_to_do_desc: "Se sei un dipendente, contatta il titolare del salone per farti riattivare l'account oppure contatta l'assistenza.",
        contact_support: "Contatta Assistenza",
        logout: "Esci e torna al Login"
      },
      toasts: {
        login_error: "Errore durante il login",
        login_success: "Login effettuato",
        user_exists_title: "Account già esistente!",
        user_exists_desc: "Questa email è già associata a un account. Accedi con email o con Google per attivare il tuo profilo business.",
        register_error: "Errore durante la registrazione",
        register_success: "Registrazione completata!",
        reset_error: "Errore durante il reset password",
        reset_success: "Email di reset inviata",
        google_error: "Errore durante il login con Google",
        unexpected_error: "Errore imprevisto"
      },
      page: {
        login: {
          title: "Accedi",
          subtitle: "Inserisci le tue credenziali per entrare."
        },
        register: {
          title: "Crea Account",
          subtitle: "Compila i dati per iniziare."
        },
        forgot: {
          title: "Recupero Password",
          subtitle: "Inserisci la tua email per ricevere il link di ripristino."
        },
        mobile: {
          no_account: "Non hai un account?",
          has_account: "Hai già un account?",
          register_btn: "Registrati",
          login_btn: "Accedi"
        },
        or_continue: "Oppure continua con",
        success: {
          title: "Controlla la tua email",
          desc: "Abbiamo inviato un link di conferma al tuo indirizzo email. Clicca sul link per attivare il tuo account e iniziare.",
          back_btn: "Torna al Login"
        }
      },
      placeholders: {
        name: "Mario Rossi",
        email: "nome@esempio.com"
      }
    },
    payment_success: {
      title: "Pagamento Completato!",
      message: "Il pagamento è stato completato con successo.",
      dashboard_btn: "Vai alla Dashboard",
      redirect: "Reindirizzamento automatico in {{count}}s"
    },
    booking_result: {
      confirmed_title: "Prenotazione Confermata!",
      confirmed_message: "La prenotazione è stata confermata con successo.",
      cancelled_title: "Prenotazione Annullata",
      cancelled_message: "La prenotazione è stata annullata come richiesto.",
      home_btn: "Torna alla Home"
    },
    referral: {
      box: {
        title: "Invita un salone",
        subtitle_prefix: "Ricevi un codice del ",
        subtitle_bold: "10% di sconto",
        cta: "Invita Ora"
      },
      dialog: {
        title: "Diventa Ambassador",
        description: "Vuoi generare il tuo codice referral? Verrà inviato a {{email}}.",
        confirm_btn: "Genera Codice",
        cancel_btn: "Annulla",
        loading: "Generazione...",
        success: "Voucher inviato alla tua email!",
        error: {
          no_email: "Email utente non trovata.",
          exists: "Voucher già richiesto! Controlla la tua email.",
          rate_limit: "Troppi tentativi. Attendi un'ora.",
          generic: "Errore durante la generazione. Riprova.",
          connection: "Errore di connessione."
        }
      }
    }

  }
};